import { Decimal } from 'decimal.js';
import { PriceAdjustmentType } from '../constants/price-adjustment-type.js';
const MIN_UNIT_PRICE = new Decimal('0.01');
// The markdown per unit, rounded to cents and clamped so the unit price never drops below $0.01; zero means no discount.
export function computeVolumeMarkdown(unitPrice, priceAdjustmentTypeId, value) {
    const price = new Decimal(unitPrice);
    const markdown = priceAdjustmentTypeId === PriceAdjustmentType.PERCENTAGE
        ? price.times(value).dividedBy(100).toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
        : new Decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
    return Decimal.max(0, Decimal.min(markdown, price.minus(MIN_UNIT_PRICE)));
}
//# sourceMappingURL=compute-volume-markdown.js.map